var render = function render() {
  var _vm$form$policySearch, _vm$form$policySearch2, _vm$form$policySearch4;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    attrs: {
      model: _vm.form
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("顶部导航配置")
    }
  }, [_c("a-checkbox-group", {
    on: {
      change: _vm.checkboxChange
    },
    model: {
      value: _vm.navCheckedList,
      callback: function ($$v) {
        _vm.navCheckedList = $$v;
      },
      expression: "navCheckedList"
    }
  }, _vm._l(_vm.form.topNavigation, function (item) {
    return _c("a-checkbox", {
      key: item.navigationMark,
      attrs: {
        value: item.navigationLabel
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.navigationLabel)) + " ")]);
  }), 1)], 1), _vm.navCheckedList.includes("保单查询") ? [_c("div", {
    staticClass: "itemsTit"
  }, [_vm._v(_vm._s(_vm.$t("保单查询配置")) + "：")]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("查询条件")
    }
  }, [_c("a-checkbox-group", {
    staticClass: "queryBox",
    on: {
      change: function ($event) {
        return _vm.searchCheckboxChange("policy");
      }
    },
    model: {
      value: _vm.policySearchCheckedList,
      callback: function ($$v) {
        _vm.policySearchCheckedList = $$v;
      },
      expression: "policySearchCheckedList"
    }
  }, _vm._l(_vm.form.policySearch.searchTerms, function (item) {
    return _c("a-checkbox", {
      key: item.termKey,
      staticStyle: {
        width: "100%",
        "margin-left": "0",
        "margin-bottom": "5px"
      },
      attrs: {
        value: item.termValue
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.termValue)) + " "), item.termKey == "appliMobile" && item.termDisplay == true ? _c("div", {
      staticStyle: {
        margin: "5px 0"
      }
    }, [_c("span", [_vm._v(_vm._s(_vm.$t("手机号验证码")) + "：")]), _c("a-radio-group", {
      model: {
        value: item.sendSMS,
        callback: function ($$v) {
          _vm.$set(item, "sendSMS", $$v);
        },
        expression: "item.sendSMS"
      }
    }, [_c("a-radio", {
      attrs: {
        value: true
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("发送")) + " ")]), _c("a-radio", {
      attrs: {
        value: false
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("不发送")) + " ")])], 1)], 1) : _vm._e()]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("按钮设置")
    }
  }, [_c("a-checkbox", {
    on: {
      change: function ($event) {
        return _vm.cardBtnChangeFun("policy", $event);
      }
    },
    model: {
      value: _vm.form.policySearch.buttonInfo.buttonDisplay,
      callback: function ($$v) {
        _vm.$set(_vm.form.policySearch.buttonInfo, "buttonDisplay", $$v);
      },
      expression: "form.policySearch.buttonInfo.buttonDisplay"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保单卡片添加按钮")) + " ")]), _vm.form.policySearch.buttonInfo.buttonDisplay ? _vm._l(_vm.form.policySearch.buttonInfo.buttons, function (buttonItem, idx) {
    return _c("div", {
      key: idx,
      staticClass: "buttonItem"
    }, [_c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮文字颜色")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("div", {
      staticClass: "colorBox",
      style: "background:" + buttonItem.buttonFontColor
    }), _c("a-button", {
      staticClass: "size",
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.colorClickFun("policySearch", idx, buttonItem.buttonFontColor, "buttonFontColor");
        }
      }
    }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮颜色")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("div", {
      staticClass: "colorBox",
      style: "background:" + buttonItem.buttonBgColor
    }), _c("a-button", {
      staticClass: "size",
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.colorClickFun("policySearch", idx, buttonItem.buttonBgColor, "buttonBgColor");
        }
      }
    }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮文案")))]), _c("a-button", {
      attrs: {
        type: "primary"
      }
    }, [_vm._v(_vm._s(_vm.$t(buttonItem.buttonName)))])], 1)]);
  }) : _vm._e()], 2), (_vm$form$policySearch = _vm.form.policySearch) !== null && _vm$form$policySearch !== void 0 && _vm$form$policySearch.invoiceInfo ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("发票配置")
    }
  }, [_c("a-checkbox", {
    on: {
      change: function ($event) {
        return _vm.invoiceBtnChangeFun("policy", $event);
      }
    },
    model: {
      value: (_vm$form$policySearch2 = _vm.form.policySearch) === null || _vm$form$policySearch2 === void 0 ? void 0 : _vm$form$policySearch2.invoiceInfo.buttonDisplay,
      callback: function ($$v) {
        var _vm$form$policySearch3;
        _vm.$set((_vm$form$policySearch3 = _vm.form.policySearch) === null || _vm$form$policySearch3 === void 0 ? void 0 : _vm$form$policySearch3.invoiceInfo, "buttonDisplay", $$v);
      },
      expression: "form.policySearch?.invoiceInfo.buttonDisplay"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("显示开具发票按钮")) + " ")])], 1) : _vm._e(), (_vm$form$policySearch4 = _vm.form.policySearch) !== null && _vm$form$policySearch4 !== void 0 && (_vm$form$policySearch4 = _vm$form$policySearch4.invoiceInfo) !== null && _vm$form$policySearch4 !== void 0 && _vm$form$policySearch4.buttonDisplay ? [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("按钮设置")
    }
  }, _vm._l(_vm.form.policySearch.invoiceInfo.buttons, function (buttonItem, idx) {
    return _c("div", {
      key: idx,
      staticClass: "buttonItem"
    }, [_c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮文字颜色")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("div", {
      staticClass: "colorBox",
      style: "background:" + buttonItem.buttonFontColor
    }), _c("a-button", {
      staticClass: "size",
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.colorClickFun("invoiceInfo", idx, buttonItem.buttonFontColor, "buttonFontColor");
        }
      }
    }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮颜色")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("div", {
      staticClass: "colorBox",
      style: "background:" + buttonItem.buttonBgColor
    }), _c("a-button", {
      staticClass: "size",
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.colorClickFun("invoiceInfo", idx, buttonItem.buttonBgColor, "buttonBgColor");
        }
      }
    }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮文案")))]), _c("a-button", {
      attrs: {
        type: "primary"
      }
    }, [_vm._v(_vm._s(_vm.$t(buttonItem.buttonName)))])], 1), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("身份校验")))]), _c("a-switch", {
      attrs: {
        checked: buttonItem.idVerity,
        "checked-children": _vm.$t("开"),
        "un-checked-children": _vm.$t("关")
      },
      on: {
        change: _vm.idVerityChange
      }
    })], 1)]);
  }), 0)] : _vm._e()] : _vm._e(), _vm.navCheckedList.includes("订单查询") ? [_c("div", {
    staticClass: "itemsTit"
  }, [_vm._v(_vm._s(_vm.$t("订单查询配置")) + "：")]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("查询条件")
    }
  }, [_c("a-checkbox-group", {
    staticClass: "queryBox",
    on: {
      change: function ($event) {
        return _vm.searchCheckboxChange("order");
      }
    },
    model: {
      value: _vm.orderSearchCheckedList,
      callback: function ($$v) {
        _vm.orderSearchCheckedList = $$v;
      },
      expression: "orderSearchCheckedList"
    }
  }, _vm._l(_vm.form.orderSearch.searchTerms, function (item) {
    return _c("a-checkbox", {
      key: item.termKey,
      staticStyle: {
        width: "100%",
        "margin-left": "0",
        "margin-bottom": "5px"
      },
      attrs: {
        value: item.termValue
      }
    }, [_vm._v(" " + _vm._s(_vm.$t(item.termValue)) + " "), item.termKey == "appliMobile" && item.termDisplay == true ? _c("div", {
      staticStyle: {
        margin: "5px 0"
      }
    }, [_c("span", [_vm._v(_vm._s(_vm.$t("手机号验证码")) + "：")]), _c("a-radio-group", {
      model: {
        value: item.sendSMS,
        callback: function ($$v) {
          _vm.$set(item, "sendSMS", $$v);
        },
        expression: "item.sendSMS"
      }
    }, [_c("a-radio", {
      attrs: {
        value: true
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("发送")) + " ")]), _c("a-radio", {
      attrs: {
        value: false
      }
    }, [_vm._v(" " + _vm._s(_vm.$t("不发送")) + " ")])], 1)], 1) : _vm._e()]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("按钮设置")
    }
  }, [_c("a-checkbox", {
    on: {
      change: function ($event) {
        return _vm.cardBtnChangeFun("order", $event);
      }
    },
    model: {
      value: _vm.form.orderSearch.buttonInfo.buttonDisplay,
      callback: function ($$v) {
        _vm.$set(_vm.form.orderSearch.buttonInfo, "buttonDisplay", $$v);
      },
      expression: "form.orderSearch.buttonInfo.buttonDisplay"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("订单卡片添加按钮")) + " ")]), _vm.form.orderSearch.buttonInfo.buttonDisplay ? _vm._l(_vm.form.orderSearch.buttonInfo.buttons, function (buttonItem, idx) {
    return _c("div", {
      key: idx,
      staticClass: "buttonItem"
    }, [_c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮文字颜色")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("div", {
      staticClass: "colorBox",
      style: "background:" + buttonItem.buttonFontColor
    }), _c("a-button", {
      staticClass: "size",
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.colorClickFun("orderSearch", idx, buttonItem.buttonFontColor, "buttonFontColor");
        }
      }
    }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮颜色")))]), _c("div", {
      staticClass: "contBox"
    }, [_c("div", {
      staticClass: "colorBox",
      style: "background:" + buttonItem.buttonBgColor
    }), _c("a-button", {
      staticClass: "size",
      attrs: {
        type: "link"
      },
      on: {
        click: function ($event) {
          return _vm.colorClickFun("orderSearch", idx, buttonItem.buttonBgColor, "buttonBgColor");
        }
      }
    }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
      staticClass: "selectedItem"
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(_vm._s(_vm.$t("按钮文案")))]), _c("a-button", {
      attrs: {
        type: "primary"
      }
    }, [_vm._v(_vm._s(_vm.$t(buttonItem.buttonName)))])], 1)]);
  }) : _vm._e()], 2)] : _vm._e()], 2), _vm.colorShow ? _c("color-model", {
    ref: "colorRef",
    on: {
      cancel: function ($event) {
        _vm.colorShow = false;
      },
      ok: _vm.colorFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };